// extracted by mini-css-extract-plugin
module.exports = {"container":"healthGoal_container__raMUF","goalContainer":"healthGoal_goalContainer__3NnLi","heading":"healthGoal_heading__1Y0nO","selected":"healthGoal_selected__2nWbF"};